import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc } from "firebase/firestore";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { firestore, getRef } from "../../utils/firebase/setupFirebase";
import { Row } from "antd";
import { Game } from "./utils/Game";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { useAddUserToGame } from "./utils/useAddUserToGame";
import { useDispatch } from "react-redux";
import { setGame, setGameRefUrl } from "../../redux/slice/game";
import { useFixingMyNameInTheGame } from "./utils/useFixingMyNameInTheGame";
import { GameMasterGameStartModal } from "./components/GameMasterGameStartModal";
import { OurLayout } from "../../components/OurLayout";
import { Helmet } from "react-helmet-async";
import { useIsSmallDevice } from "../../hooks/useIsSmallDevice";
import { LargeDeviceView } from "./components/LargeDeviceView/LargeDeviceView";
import { SmallDeviceView } from "./components/SmallDeviceView/SmallDeviceView";

export const GameScreen = () => {
  const params = useParams<{ gameId: string }>();
  const [browserSupported, setBrowserSupported] = useState<boolean>(true);
  const dispatch = useDispatch();
  const roomId = "werBinIch-" + params.gameId!;
  const gameRefUrl = getRef(["games", params.gameId!]);
  const gameRef = doc(firestore, gameRefUrl);
  useFixingMyNameInTheGame();
  const [game, loadingGame] = useDocumentData<Game>(gameRef);

  const isSmallDevice = useIsSmallDevice();

  useEffect(() => {
    dispatch(setGame(game));

    //eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [game]);

  useEffect(() => {
    dispatch(setGameRefUrl(gameRefUrl));
    //eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [gameRefUrl]);
  useAddUserToGame({ game, gameRef: gameRef });

  if (!browserSupported) {
    //return <div/>
  }

  return (
    <OurLayout>
      <Helmet title={"Wer bin ich - Spiel"} />
      <Row gutter={[0, 16]} style={{ height: "100%" }}>
        {loadingGame && <LoadingOverlay />}
        {isSmallDevice ? (
          <SmallDeviceView
            gameRef={gameRef}
            roomId={roomId}
            setBrowserSupported={setBrowserSupported}
          />
        ) : (
          <LargeDeviceView
            gameRef={gameRef}
            roomId={roomId}
            setBrowserSupported={setBrowserSupported}
          />
        )}
        <GameMasterGameStartModal />
      </Row>
    </OurLayout>
  );
};
